import { Helpers } from '../../../core/src/helpers';

export const loggedOutProps = (loginURL, signUpURL, learnMoreURL) => {
    const DEFAULT_UNKNOWN_USER_TITLE = 'Welcome!';
    const DEFAULT_UNKNOWN_USER_MSG_TITLE = 'Unlock Your Exclusive Offer!';
    const DEFAULT_UNKNOWN_USER_MSG_CONTENT =
        '<p>Log in to access special pricing and benefits available to you. New here?</p><p>Sign up* today and start saving.</p>';
    const DEFAULT_UNKNOWN_USER_CTA_PROPS = {
        learnMoreCTAProps: { link: learnMoreURL, label: '*Learn more' },
        btns: [
            { link: Helpers.decodeHtml(signUpURL), label: 'Sign up', variation: 'secondary' },
            { link: Helpers.decodeHtml(loginURL), label: 'Log in' },
        ],
    };
    return {
        title: DEFAULT_UNKNOWN_USER_TITLE,
        msgBlockTitle: DEFAULT_UNKNOWN_USER_MSG_TITLE,
        msgBlockContent: DEFAULT_UNKNOWN_USER_MSG_CONTENT,
        ctaProps: DEFAULT_UNKNOWN_USER_CTA_PROPS,
    };
};

export const generalStoreProps = (name, signUpURL, learnMoreURL) => {
    const DEFAULT_SS_PS_USER_TITLE = 'Hello ' + name + '!';
    const DEFAULT_SS_PS_USER_MSG_CONTENT =
        '<p>We noticed that your account under this email is aligned under a different HP program.</p><p>Please create a new Store account* with an alternate email to receive your exclusive HP offer!</p>';
    const DEFAULT_SS_PS_USER_CTA_PROPS = {
        btns: [{ link: Helpers.decodeHtml(signUpURL), label: 'Sign up' }],
        learnMoreCTAProps: { link: learnMoreURL, label: '*Learn more' },
    };
    return {
        title: DEFAULT_SS_PS_USER_TITLE,
        msgBlockContent: DEFAULT_SS_PS_USER_MSG_CONTENT,
        ctaProps: DEFAULT_SS_PS_USER_CTA_PROPS,
    };
};

export const softSignInProps = (name, loginURL, learnMoreURL) => {
    const DEFAULT_SS_PS_USER_TITLE = 'Welcome back ' + name + '!';
    const DEFAULT_SS_PS_USER_MSG_CONTENT =
        '<p>Log in now to unlock your special student pricing and make the most of your shopping experience.</p>';
    const DEFAULT_SS_PS_USER_CTA_PROPS = {
        btns: [{ link: Helpers.decodeHtml(loginURL), label: 'Log in' }],
        learnMoreCTAProps: { link: learnMoreURL, label: '*Learn more' },
    };
    return {
        title: DEFAULT_SS_PS_USER_TITLE,
        msgBlockContent: DEFAULT_SS_PS_USER_MSG_CONTENT,
        ctaProps: DEFAULT_SS_PS_USER_CTA_PROPS,
    };
};
